"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TertiaryNavIdentifier = exports.SecondaryNavIdentifier = exports.PrimaryNavIdentifier = exports.FeatureFlagsProductType = void 0;

/**
 *  MODAL
 */
var OPEN_MODAL_EVENT = 'OPEN_MODAL_EVENT';
var MODAL_TYPE_CART = 'CART_MODAL';
var MODAL_TYPE_AUTH = 'AUTH';
var MODAL_TYPE_PUBLISH_REGISTRY = 'PUBLISH_REGISTRY';
var MODAL_TYPE_SET_SHIPPING_ADDRESS = 'SET_SHIPPING_ADDRESS';
var MODAL_TYPE_SHIPPING_EXCLUSION = 'SHIPPING_EXCLUSION';
var MODAL_TYPE_BOOKING_STATUS_REMINDER = 'BOOKING_STATUS_REMINDER';
var MODAL_TYPE_TWOFA_ACTION = 'TWOFA_ACTION'; // NOTE: Dispatched from 'Public Registry (web-registry)'

var PUBLIC_REGISTRY_EVENT = 'PUBLIC_REGISTRY_EVENT';
/**
 *  NAV V2
 */

var NAV_LOADED = 'NAV_LOADED';
/**
 * Custom event payload for indicating that a jewel should be shown on a menu item
 * in the nav. Cab be dispatched by web-** apps
 *
 * @example
 *   window.dispatchEvent(
 *     new CustomEvent<NavJewelEventPayload>(
 *       NAV_JEWEL_CUSTOM_EVENT,
 *       {
 *         detail: { showVendorsJewel: true }
 *       }
 *     )
 *   )
 */

var NAV_JEWEL_CUSTOM_EVENT = 'NAV_JEWEL_CUSTOM_EVENT';
/**
 * Custom event triggered when navigation data is available from a web-product
 * (marketplace/registry/wedding/etc) and the navigation menu needs to know about it
 *
 *
 * @example
 *     window.dispatchEvent(
 *       new CustomEvent(INIT_NAV_DATA, {
 *        detail: {
 *          secondaryData,
 *          userContext,
 *          activePrimaryLink,
 *          activeSecondaryLink,
 *        },
 *      })
 *    );
 *
 * @example
 *    window.dispatchEvent(
 *      new CustomEvent<InitNavDataEventPayload>(INIT_NAV_DATA, {
 *        detail: {
 *          secondaryData,
 *          userContext,
 *          activePrimaryLink,
 *          activeSecondaryLink,
 *        },
 *      })
 *    );
 *
 *  */

var INIT_NAV_DATA = 'INIT_NAV_DATA';
var NAV_PRIMARY_RENDERED = 'NAV_PRIMARY_RENDERED';
var NAV_SECONDARY_RENDERED = 'NAV_SECONDARY_RENDERED';
/**
 * Constants used in web-nav to segment feature flag toggles by product
 */

var FeatureFlagsProductType;
/**
 * The setting for a feature flag, as communicated to web-nav, for a
 * specific product.  For example, this tells web nav the feature flag 'best-feature-ever'
 * is set to true, and its value in production is false.
 */

exports.FeatureFlagsProductType = FeatureFlagsProductType;

(function (FeatureFlagsProductType) {
  FeatureFlagsProductType["WEB_MARKETPLACE"] = "MARKETPLACE";
  FeatureFlagsProductType["WEB_NAV"] = "NAV";
  FeatureFlagsProductType["WEB_WEDDING"] = "WEDDING";
  FeatureFlagsProductType["WEB_REGISTRY"] = "REGISTRY";
  FeatureFlagsProductType["WEB_STORE"] = "STORE";
  FeatureFlagsProductType["WEB_PRE_AUTH"] = "PRE_AUTH";
})(FeatureFlagsProductType || (exports.FeatureFlagsProductType = FeatureFlagsProductType = {}));

/**
 * Custom event for signaling that feature flags are available
 *
 * Custom Event should provide a payload of type FeatureFlagsAvailableEventPayload
 *
 * @example
 *    window.dispatchEvent(
 *      new CustomEvent(FEATURE_FLAGS_AVAILABLE, {
 *        detail: {
 *          domain: FeatureFlagProductType.MARKETPLACE,
 *          flags: [
 *             'best-feature-ever': { value: true, production: false, staging: true, development: false }
 *          ]
 *        },
 *      })
 *    );
 *
 * @example
 *    window.dispatchEvent(
 *      new CustomEvent<FeatureFlagsAvailableEventPayload>(FEATURE_FLAGS_AVAILABLE, {
 *        detail: featureFlagAvailablePayload,
 *      })
 *    );
 *
 */
var FEATURE_FLAGS_AVAILABLE = 'FEATURE_FLAGS_AVAILABLE';
var PrimaryNavIdentifier;
exports.PrimaryNavIdentifier = PrimaryNavIdentifier;

(function (PrimaryNavIdentifier) {
  PrimaryNavIdentifier["REGISTRY"] = "registry";
  PrimaryNavIdentifier["WEBSITE"] = "website";
  PrimaryNavIdentifier["PAPER"] = "invites";
  PrimaryNavIdentifier["ALBUMS"] = "albums";
  PrimaryNavIdentifier["GUEST_LIST"] = "guestList";
  PrimaryNavIdentifier["WEDDING_BOUTIQUE"] = "weddingBoutique";
  PrimaryNavIdentifier["ADVICE"] = "advice";
  PrimaryNavIdentifier["VENDORS"] = "vendors";
  PrimaryNavIdentifier["ACCOUNT"] = "account";
  PrimaryNavIdentifier["COMMUNITY"] = "community";
  PrimaryNavIdentifier["BUDGET"] = "budget";
  PrimaryNavIdentifier["CAREERS"] = "careers";
  PrimaryNavIdentifier["CHECKLIST"] = "checklist";
  PrimaryNavIdentifier["HELP"] = "help";
  PrimaryNavIdentifier["OUR_STORY"] = "ourStory";
  PrimaryNavIdentifier["PRESS"] = "press";
  PrimaryNavIdentifier["REAL_WEDDINGS"] = "realWeddings";
  PrimaryNavIdentifier["SEATING"] = "seating";
  PrimaryNavIdentifier["YOUR_WEDDING"] = "yourWedding";
})(PrimaryNavIdentifier || (exports.PrimaryNavIdentifier = PrimaryNavIdentifier = {}));

var SecondaryNavIdentifier;
exports.SecondaryNavIdentifier = SecondaryNavIdentifier;

(function (SecondaryNavIdentifier) {
  SecondaryNavIdentifier["YOUR_REGISTRY"] = "your-registry";
  SecondaryNavIdentifier["NEW_ARRIVALS"] = "new-arrivals";
  SecondaryNavIdentifier["COLLECTIONS"] = "collections";
  SecondaryNavIdentifier["BRANDS"] = "brands";
  SecondaryNavIdentifier["EXPERIENCES"] = "experiences";
  SecondaryNavIdentifier["CASH_FUNDS"] = "cash-funds";
  SecondaryNavIdentifier["SALE"] = "sale";
  SecondaryNavIdentifier["REGISTRY_OVERVIEW"] = "registry-overview";
  SecondaryNavIdentifier["MANAGE_REGISTRY"] = "manage-registry";
  SecondaryNavIdentifier["CHECKLIST"] = "checklist";
  SecondaryNavIdentifier["GIFT_TRACKER"] = "gift-tracker";
  SecondaryNavIdentifier["DISNEY"] = "disney";
  SecondaryNavIdentifier["DAY_OF"] = "day-of-paper";
  SecondaryNavIdentifier["INVITATION"] = "invitations";
  SecondaryNavIdentifier["SAVE_THE_DATE"] = "save-the-date";
  SecondaryNavIdentifier["MATCHING_SUITES"] = "matching-suits";
  SecondaryNavIdentifier["DIGITAL_SAVE_THE_DATE"] = "digital-save-the-date";
  SecondaryNavIdentifier["CHANGE_THE_DATE"] = "change-the-date";
  SecondaryNavIdentifier["PLACE"] = "place-cards";
  SecondaryNavIdentifier["THANK_YOU"] = "thank-you-cards";
  SecondaryNavIdentifier["MENU"] = "menus";
  SecondaryNavIdentifier["DETAILS"] = "enclosures";
  SecondaryNavIdentifier["PROGRAM"] = "programs";
  SecondaryNavIdentifier["HOLIDAY"] = "holiday-cards";
  SecondaryNavIdentifier["FREE_SAMPLES"] = "free-samples";
  SecondaryNavIdentifier["PROJECTS"] = "projects";
  SecondaryNavIdentifier["WEDDING_SHOWER_INVITATION"] = "wedding-shower";
  SecondaryNavIdentifier["PAPER_DRAFTS_AND_ORDERS"] = "paper-drafts-and-orders";
  SecondaryNavIdentifier["PAPER_SHOP"] = "paper-shop";
  SecondaryNavIdentifier["ALL_GUESTS"] = "guests";
  SecondaryNavIdentifier["EVENTS"] = "events";
  SecondaryNavIdentifier["BUILD"] = "build";
  SecondaryNavIdentifier["ENVELOPES"] = "envelopes";
  SecondaryNavIdentifier["TRACK_RSVPS"] = "rsvp-overview";
  SecondaryNavIdentifier["RSVP_REQUESTS"] = "rsvp-notifications";
  SecondaryNavIdentifier["SEATING"] = "seating";
  SecondaryNavIdentifier["SUPER_LINK"] = "super-link";
  SecondaryNavIdentifier["MANAGE"] = "manange";
  SecondaryNavIdentifier["EDIT"] = "edit";
  SecondaryNavIdentifier["DESIGNS"] = "designs";
  SecondaryNavIdentifier["CUSTOMIZE"] = "customize";
  SecondaryNavIdentifier["BUDGET"] = "budget";
  SecondaryNavIdentifier["EXPLORE_VENDORS"] = "marketplace-vendors";
  SecondaryNavIdentifier["VENDOR_CONNECTIONS"] = "marketplace-connections";
  SecondaryNavIdentifier["BOOKED_VENDORS"] = "marketplace-booked-vendors";
  SecondaryNavIdentifier["BECOME_VENDOR"] = "marketplace-become-vendor";
  SecondaryNavIdentifier["REAL_WEDDINGS"] = "real-weddings";
  SecondaryNavIdentifier["YOUR_FAVORITES"] = "your-favorites";
  SecondaryNavIdentifier["ALBUMS_DRAFTS"] = "DRAFTS";
  SecondaryNavIdentifier["ALBUMS_SHOP"] = "SHOP";
  SecondaryNavIdentifier["ALBUMS_CLASSIC"] = "CLASSIC";
  SecondaryNavIdentifier["ALBUMS_PREMIER"] = "PREMIER";
  SecondaryNavIdentifier["ALBUMS_DELUXE"] = "DELUXE";
})(SecondaryNavIdentifier || (exports.SecondaryNavIdentifier = SecondaryNavIdentifier = {}));

var TertiaryNavIdentifier;
exports.TertiaryNavIdentifier = TertiaryNavIdentifier;

(function (TertiaryNavIdentifier) {
  TertiaryNavIdentifier["MANAGE_GUEST_LIST"] = "manage-guest-list";
  TertiaryNavIdentifier["INVITE_GUESTS"] = "invite-guests";
  TertiaryNavIdentifier["ADDRESS_ENVELOPES"] = "address-envelopes";
  TertiaryNavIdentifier["TRACK_RSVPS"] = "track-rsvps";
  TertiaryNavIdentifier["COLLECTIONS_PAPER"] = "collections-paper";
  TertiaryNavIdentifier["SAVE_THE_DATE"] = "save-the-date";
  TertiaryNavIdentifier["INVITATIONS"] = "invitations";
  TertiaryNavIdentifier["DAY_OF"] = "day-of";
  TertiaryNavIdentifier["THANK_YOUS"] = "thank-yous";
  TertiaryNavIdentifier["DIGITAL_SAVE_THE_DATE"] = "digital-save-the-date";
  TertiaryNavIdentifier["ALBUMS"] = "albums";
  TertiaryNavIdentifier["NEW_REGISTRY"] = "new-registry";
  TertiaryNavIdentifier["COLLECTIONS_REGISTRY"] = "collections-registry";
  TertiaryNavIdentifier["BRANDS"] = "brands";
  TertiaryNavIdentifier["KITCHEN"] = "kitchen";
  TertiaryNavIdentifier["TABLETOP"] = "tabletop";
  TertiaryNavIdentifier["BED_BATH"] = "bed-bath";
  TertiaryNavIdentifier["FURNITURE"] = "furniture";
  TertiaryNavIdentifier["HOME"] = "home";
  TertiaryNavIdentifier["WEEKEND"] = "weekend";
  TertiaryNavIdentifier["EXPERIENCES"] = "experiences";
  TertiaryNavIdentifier["CASH_FUNDS"] = "cash-funds";
  TertiaryNavIdentifier["NEW_BOUTIQUE"] = "new-boutique";
  TertiaryNavIdentifier["BRIDAL"] = "bridal";
  TertiaryNavIdentifier["WEDDING_PARTY"] = "wedding-party";
  TertiaryNavIdentifier["ACCESSORIES"] = "accessories";
  TertiaryNavIdentifier["JEWELRY"] = "jewelry";
  TertiaryNavIdentifier["PARTY_SUPPLIES_DECOR"] = "party-supplies-decor";
  TertiaryNavIdentifier["GIFTS_FAVORS"] = "gifts-favors";
  TertiaryNavIdentifier["INTIMATES"] = "intimates";
  TertiaryNavIdentifier["BEAUTY_WELLNESS"] = "beauty-wellness";
})(TertiaryNavIdentifier || (exports.TertiaryNavIdentifier = TertiaryNavIdentifier = {}));

var NAV_DATA = {
  PRIMARY: {
    REGISTRY: PrimaryNavIdentifier.REGISTRY,
    WEBSITE: PrimaryNavIdentifier.WEBSITE,
    PAPER: PrimaryNavIdentifier.PAPER,
    ALBUMS: PrimaryNavIdentifier.ALBUMS,
    GUEST_LIST: PrimaryNavIdentifier.GUEST_LIST,
    WEDDING_BOUTIQUE: PrimaryNavIdentifier.WEDDING_BOUTIQUE,
    ADVICE: PrimaryNavIdentifier.ADVICE,
    VENDORS: PrimaryNavIdentifier.VENDORS,
    ACCOUNT: PrimaryNavIdentifier.ACCOUNT,
    COMMUNITY: PrimaryNavIdentifier.COMMUNITY,
    BUDGET: PrimaryNavIdentifier.BUDGET,
    CAREERS: PrimaryNavIdentifier.CAREERS,
    CHECKLIST: PrimaryNavIdentifier.CHECKLIST,
    HELP: PrimaryNavIdentifier.HELP,
    OUR_STORY: PrimaryNavIdentifier.OUR_STORY,
    PRESS: PrimaryNavIdentifier.PRESS,
    REAL_WEDDINGS: PrimaryNavIdentifier.REAL_WEDDINGS,
    SEATING: PrimaryNavIdentifier.SEATING,
    YOUR_WEDDING: PrimaryNavIdentifier.YOUR_WEDDING
  },
  SECONDARY: {
    REGISTRY: {
      YOUR_REGISTRY: SecondaryNavIdentifier.YOUR_REGISTRY,
      NEW_ARRIVALS: SecondaryNavIdentifier.NEW_ARRIVALS,
      COLLECTIONS: SecondaryNavIdentifier.COLLECTIONS,
      BRANDS: SecondaryNavIdentifier.BRANDS,
      EXPERIENCES: SecondaryNavIdentifier.EXPERIENCES,
      CASH_FUNDS: SecondaryNavIdentifier.CASH_FUNDS,
      SALE: SecondaryNavIdentifier.SALE,
      REGISTRY_OVERVIEW: SecondaryNavIdentifier.REGISTRY_OVERVIEW,
      MANAGE_REGISTRY: SecondaryNavIdentifier.MANAGE_REGISTRY,
      CHECKLIST: SecondaryNavIdentifier.CHECKLIST,
      GIFT_TRACKER: SecondaryNavIdentifier.GIFT_TRACKER
    },
    PAPER: {
      INVITATION: SecondaryNavIdentifier.INVITATION,
      SAVE_THE_DATE: SecondaryNavIdentifier.SAVE_THE_DATE,
      DIGITAL_SAVE_THE_DATE: SecondaryNavIdentifier.DIGITAL_SAVE_THE_DATE,
      CHANGE_THE_DATE: SecondaryNavIdentifier.CHANGE_THE_DATE,
      PLACE: SecondaryNavIdentifier.PLACE,
      THANK_YOU: SecondaryNavIdentifier.THANK_YOU,
      MENU: SecondaryNavIdentifier.MENU,
      DETAILS: SecondaryNavIdentifier.DETAILS,
      PROGRAM: SecondaryNavIdentifier.PROGRAM,
      HOLIDAY: SecondaryNavIdentifier.HOLIDAY,
      FREE_SAMPLES: SecondaryNavIdentifier.FREE_SAMPLES,
      PROJECTS: SecondaryNavIdentifier.PROJECTS,
      YOUR_FAVORITES: SecondaryNavIdentifier.YOUR_FAVORITES,
      MATCHING_SUITES: SecondaryNavIdentifier.MATCHING_SUITES,
      WEDDING_SHOWER_INVITATION: SecondaryNavIdentifier.WEDDING_SHOWER_INVITATION,
      PAPER_DRAFTS_AND_ORDERS: SecondaryNavIdentifier.PAPER_DRAFTS_AND_ORDERS,
      PAPER_SHOP: SecondaryNavIdentifier.PAPER_SHOP
    },
    GUEST_LIST: {
      ALL_GUESTS: SecondaryNavIdentifier.ALL_GUESTS,
      EVENTS: SecondaryNavIdentifier.EVENTS,
      BUILD: SecondaryNavIdentifier.BUILD,
      ENVELOPES: SecondaryNavIdentifier.ENVELOPES,
      TRACK_RSVPS: SecondaryNavIdentifier.TRACK_RSVPS,
      RSVP_REQUESTS: SecondaryNavIdentifier.RSVP_REQUESTS,
      SEATING: SecondaryNavIdentifier.SEATING,
      SUPER_LINK: SecondaryNavIdentifier.SUPER_LINK
    },
    WEBSITE: {
      MANAGE: SecondaryNavIdentifier.MANAGE,
      EDIT: SecondaryNavIdentifier.EDIT,
      CUSTOMIZE: SecondaryNavIdentifier.CUSTOMIZE,
      DESIGNS: SecondaryNavIdentifier.DESIGNS,
      BUDGET: SecondaryNavIdentifier.BUDGET
    },
    MARKETPLACE: {
      EXPLORE_VENDORS: SecondaryNavIdentifier.EXPLORE_VENDORS,
      VENDOR_CONNECTIONS: SecondaryNavIdentifier.VENDOR_CONNECTIONS,
      BOOKED_VENDORS: SecondaryNavIdentifier.BOOKED_VENDORS,
      BECOME_VENDOR: SecondaryNavIdentifier.BECOME_VENDOR,
      REAL_WEDDINGS: SecondaryNavIdentifier.REAL_WEDDINGS,
      YOUR_FAVORITES: SecondaryNavIdentifier.YOUR_FAVORITES
    },
    ALBUMS: {
      DRAFTS: SecondaryNavIdentifier.ALBUMS_DRAFTS,
      SHOP: SecondaryNavIdentifier.ALBUMS_SHOP,
      CLASSIC: SecondaryNavIdentifier.ALBUMS_CLASSIC,
      PREMIER: SecondaryNavIdentifier.ALBUMS_PREMIER,
      DELUXE: SecondaryNavIdentifier.ALBUMS_DELUXE
    }
  },
  TERTIARY: {
    GUEST_LIST: {
      MANAGE_GUEST_LIST: TertiaryNavIdentifier.MANAGE_GUEST_LIST,
      INVITE_GUESTS: TertiaryNavIdentifier.INVITE_GUESTS,
      ADDRESS_ENVELOPES: TertiaryNavIdentifier.ADDRESS_ENVELOPES,
      TRACK_RSVPS: TertiaryNavIdentifier.TRACK_RSVPS
    },
    PAPER: {
      COLLECTIONS_PAPER: TertiaryNavIdentifier.COLLECTIONS_PAPER,
      SAVE_THE_DATE: TertiaryNavIdentifier.SAVE_THE_DATE,
      INVITATIONS: TertiaryNavIdentifier.INVITATIONS,
      DAY_OF: TertiaryNavIdentifier.DAY_OF,
      THANK_YOUS: TertiaryNavIdentifier.THANK_YOUS,
      DIGITAL_SAVE_THE_DATE: TertiaryNavIdentifier.DIGITAL_SAVE_THE_DATE,
      ALBUMS: TertiaryNavIdentifier.ALBUMS
    },
    REGISTRY: {
      NEW_REGISTRY: TertiaryNavIdentifier.NEW_REGISTRY,
      COLLECTIONS_REGISTRY: TertiaryNavIdentifier.COLLECTIONS_REGISTRY,
      BRANDS: TertiaryNavIdentifier.BRANDS,
      KITCHEN: TertiaryNavIdentifier.KITCHEN,
      TABLETOP: TertiaryNavIdentifier.TABLETOP,
      BED_BATH: TertiaryNavIdentifier.BED_BATH,
      FURNITURE: TertiaryNavIdentifier.FURNITURE,
      HOME: TertiaryNavIdentifier.HOME,
      WEEKEND: TertiaryNavIdentifier.WEEKEND,
      EXPERIENCES: TertiaryNavIdentifier.EXPERIENCES,
      CASH_FUNDS: TertiaryNavIdentifier.CASH_FUNDS
    },
    BOUTIQUE: {
      NEW_BOUTIQUE: TertiaryNavIdentifier.NEW_BOUTIQUE,
      BRIDAL: TertiaryNavIdentifier.BRIDAL,
      WEDDING_PARTY: TertiaryNavIdentifier.WEDDING_PARTY,
      ACCESSORIES: TertiaryNavIdentifier.ACCESSORIES,
      JEWELRY: TertiaryNavIdentifier.JEWELRY,
      PARTY_SUPPLIES_DECOR: TertiaryNavIdentifier.PARTY_SUPPLIES_DECOR,
      GIFTS_FAVORS: TertiaryNavIdentifier.GIFTS_FAVORS,
      INTIMATES: TertiaryNavIdentifier.INTIMATES,
      BEAUTY_WELLNESS: TertiaryNavIdentifier.BEAUTY_WELLNESS
    }
  },
  EVENTS: {
    OPEN_MODAL_EVENT: OPEN_MODAL_EVENT,
    MODAL_TYPE_CART: MODAL_TYPE_CART,
    MODAL_TYPE_AUTH: MODAL_TYPE_AUTH,
    MODAL_TYPE_PUBLISH_REGISTRY: MODAL_TYPE_PUBLISH_REGISTRY,
    MODAL_TYPE_SET_SHIPPING_ADDRESS: MODAL_TYPE_SET_SHIPPING_ADDRESS,
    MODAL_TYPE_SHIPPING_EXCLUSION: MODAL_TYPE_SHIPPING_EXCLUSION,
    MODAL_TYPE_BOOKING_STATUS_REMINDER: MODAL_TYPE_BOOKING_STATUS_REMINDER,
    MODAL_TYPE_TWOFA_ACTION: MODAL_TYPE_TWOFA_ACTION,
    NAV_LOADED: NAV_LOADED,
    INIT_NAV_DATA: INIT_NAV_DATA,
    PUBLIC_REGISTRY_EVENT: PUBLIC_REGISTRY_EVENT,
    NAV_PRIMARY_RENDERED: NAV_PRIMARY_RENDERED,
    NAV_SECONDARY_RENDERED: NAV_SECONDARY_RENDERED,
    FEATURE_FLAGS_AVAILABLE: FEATURE_FLAGS_AVAILABLE,
    NAV_JEWEL_CUSTOM_EVENT: NAV_JEWEL_CUSTOM_EVENT
  }
};
var _default = NAV_DATA;
exports.default = _default;